import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { breakpointDown } from '../../../../services/responsive/responsive';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  mobileOnly: PropTypes.bool,
};

const MainHeader = memo(({ children, className, mobileOnly = false }) => {
  const isMobile = useMediaQuery(breakpointDown('sm'));

  const classes = classNames({
    'pro-wrapper-main-header': !mobileOnly || isMobile,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
});

MainHeader.propTypes = propTypes;
MainHeader.displayName = 'MainHeader';

export default MainHeader;
